<template>
  <div
    :key="item.title"
    class="puzzle-article-item"
  >
    <a
      class="puzzle-article-item-photo"
      :href="item.link"
      @click.prevent="handleClick"
    >
      <img
        :src="item.photo"
        :alt="item.title"
        loading="lazy"
      />
    </a>

    <a
      class="puzzle-article-item-title"
      :href="item.link"
      @click.prevent="handleClick"
    >
      <span v-html="item.title" />
      <span v-html="item.intro" />
      <div class="puzzle-article-item-date">{{ getDate(item.publishedAt) }}</div>
    </a>
  </div>
</template>

<script lang="ts" setup>
  import type { ArticleInList } from '@/shared/models/articleInList';
  import { formatDate, calendarFormatMonths } from '@/shared/utils/time';

  interface Props {
    /**
     * Статья со ссылкой.
     */
    item: ArticleInList & { link: string };

    /**
     * Номер элемента в списке.
     */
    position: number;
  }

  defineProps<Props>();

  const getDate = (date: number | string | Date) => {
    if (!date) {
      return;
    }

    const currentTime = new Date();
    const year = currentTime.getFullYear();
    const getYear = Number(formatDate(date, 'yyyy'));
    const format = year === getYear ? 'd MMMM' : 'd MMMM yyyy';

    return calendarFormatMonths(date, format);
  };

  const handleClick = () => {};
</script>

<style lang="scss" scoped>
  .puzzle-article-item {
    display: flex;
    flex-direction: column;
    gap: 16px;
    height: fit-content;
    cursor: pointer;
  }

  .puzzle-article-item-title {
    display: flex;
    flex-direction: column;
    gap: 8px;
    height: min-content;
    color: var(--alias-color-text-default);
    text-decoration: none;
    word-break: break-word;

    span {
      &:first-of-type {
        @include base-700-500-extra;

        @include tablet {
          @include base-500-400-extra;
        }
      }

      &:last-of-type {
        display: -webkit-box;
        overflow: hidden;
        width: 100%;
        text-overflow: ellipsis;
        -webkit-line-clamp: 8;
        -webkit-box-orient: vertical;

        @include base-400-400-regular;
      }
    }

    @include tablet {
      gap: 0;
    }
  }

  .puzzle-article-item-date {
    color: var(--alias-color-text-subtle);

    @include base-300-300-regular;

    @include tablet {
      margin-top: 4px;
    }
  }

  .puzzle-article-item-photo {
    overflow: hidden;
    border-radius: 8px;
    cursor: pointer;
    transform: translateZ(0);

    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      transition: transform 0.7s ease;
    }

    &:after {
      content: '';
      position: absolute;
      top: 0;
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 8px;
      box-shadow: inset 0 0 0 1px var(--global-color-transparent-black-a050);
    }

    @include mobile {
      aspect-ratio: 16/10 !important;
    }
  }
</style>
